// extracted by mini-css-extract-plugin
export default {"brandPromo":"bH-z","carousel":"cH-z"};